const SELECTOR = '.single-content__share-link';
const LABEL_ATTR = 'data-share-label';
const COPIED_TEXT = 'Link Copied!';
const RESET_DELAY = 2000;

const ShareLink = {
	init() {
		document.querySelectorAll<HTMLButtonElement>(SELECTOR).forEach((btn) => {
			const textNode = this.getTextNode(btn);
			if (textNode) {
				btn.setAttribute(LABEL_ATTR, textNode.textContent?.trim() ?? '');
			}
			btn.addEventListener('click', () => this.copy(btn));
		});
	},

	getTextNode(btn: HTMLButtonElement): Text | null {
		for (const node of btn.childNodes) {
			if (node.nodeType === Node.TEXT_NODE && node.textContent?.trim()) {
				return node as Text;
			}
		}
		return null;
	},

	async copy(btn: HTMLButtonElement) {
		const url = btn.dataset.shareUrl;
		if (!url) return;

		try {
			await navigator.clipboard.writeText(url);
		} catch {
			this.legacyCopy(url);
		}

		const textNode = this.getTextNode(btn);
		if (!textNode) return;

		const original = btn.getAttribute(LABEL_ATTR) ?? textNode.textContent ?? '';
		textNode.textContent = ` ${COPIED_TEXT} `;

		setTimeout(() => {
			textNode.textContent = ` ${original} `;
		}, RESET_DELAY);
	},

	legacyCopy(text: string) {
		const textarea = document.createElement('textarea');
		textarea.value = text;
		textarea.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
		document.body.appendChild(textarea);
		textarea.select();
		document.execCommand('copy');
		textarea.remove();
	},
};

export default ShareLink;
